module.exports = __webpack_public_path__ + "img/loading.09c8dde.png";